export const setPagination = pagination => {
  sessionStorage.setItem('pagination', JSON.stringify(pagination));
};

export const getPagination = () => {
  const pagination = JSON.parse(sessionStorage.getItem('pagination'));
  return pagination ? pagination : {};
};
